import { render } from "./SearchResultComponent.vue?vue&type=template&id=1f8dfb37&scoped=true&ts=true"
import script from "./SearchResultComponent.vue?vue&type=script&lang=ts"
export * from "./SearchResultComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8dfb37"]])

export default __exports__